module.exports = __webpack_public_path__ + "img/canpay-logo.99cbd458.png";